import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { invoicesApi } from '../api/invoices';
import { queryKeys } from '../lib/queryKeys';
import type { PaginationParams } from '../types/api';
import type { AdminBatchReprocessRequest } from '../types/invoices';

export function useInvoicesList(params: PaginationParams & { status?: string; organization_id?: string }) {
  return useQuery({ queryKey: queryKeys.invoices.list(params), queryFn: () => invoicesApi.list(params) });
}

export function useInvoiceDetail(id: string) {
  return useQuery({ queryKey: queryKeys.invoices.detail(id), queryFn: () => invoicesApi.detail(id), enabled: !!id });
}

export function useReprocessInvoice() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => invoicesApi.reprocess(id),
    onSuccess: (_, id) => { qc.invalidateQueries({ queryKey: queryKeys.invoices.detail(id) }); qc.invalidateQueries({ queryKey: queryKeys.invoices.all }); message.success('Invoice queued for reprocessing'); },
  });
}

export function useBatchReprocess() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: AdminBatchReprocessRequest) => invoicesApi.batchReprocess(data),
    onSuccess: () => { qc.invalidateQueries({ queryKey: queryKeys.invoices.all }); message.success('Batch reprocessing started'); },
  });
}

export function useDeleteInvoice() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => invoicesApi.deleteInvoice(id),
    onSuccess: () => { qc.invalidateQueries({ queryKey: queryKeys.invoices.all }); message.success('Invoice deleted'); },
  });
}
